import type { AxiosInstance } from 'axios';

type PermissionsEnvelope = {
  value?: string[];
};

export function normalizePermissionsResponse(response: unknown): string[] {
  if (Array.isArray(response)) {
    return response.filter((permission): permission is string => {
      return typeof permission === 'string';
    });
  }

  if (response && typeof response === 'object') {
    const envelope = response as PermissionsEnvelope;
    if (Array.isArray(envelope.value)) {
      return envelope.value.filter((permission): permission is string => {
        return typeof permission === 'string';
      });
    }
  }

  return [];
}

export async function getBackendPermissions(
  authorizedAxios: AxiosInstance
): Promise<string[]> {
  const response = await authorizedAxios.get('/api/personal/permissions');
  return normalizePermissionsResponse(response.data);
}
